function cov_2aran6gzex() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Rate.tsx";
  var hash = "442d94efe170f28643601e5659752bc889b0238b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Rate.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "442d94efe170f28643601e5659752bc889b0238b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aran6gzex = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2aran6gzex();
var Icon = (cov_2aran6gzex().s[0]++, {
  name: 'rate',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.22222 1C1.54721 1 1 1.54721 1 2.22222V21.7778C1 22.4528 1.54721 23 2.22222 23H21.7778C22.4528 23 23 22.4528 23 21.7778V2.22222C23 1.54721 22.4528 1 21.7778 1H2.22222ZM7.43837 9.55556C8.4509 9.55556 9.27171 8.73474 9.27171 7.72222C9.27171 6.7097 8.4509 5.88889 7.43837 5.88889C6.42585 5.88889 5.60504 6.7097 5.60504 7.72222C5.60504 8.73474 6.42585 9.55556 7.43837 9.55556ZM18.4384 16.2778C18.4384 17.2903 17.6176 18.1111 16.605 18.1111C15.5925 18.1111 14.7717 17.2903 14.7717 16.2778C14.7717 15.2653 15.5925 14.4444 16.605 14.4444C17.6176 14.4444 18.4384 15.2653 18.4384 16.2778ZM17.3581 8.51868C17.9547 7.92204 17.9547 6.95471 17.3581 6.35807C16.7614 5.76144 15.7941 5.76144 15.1975 6.35807L6.35807 15.1975C5.76144 15.7941 5.76144 16.7614 6.35807 17.3581C6.95471 17.9547 7.92204 17.9547 8.51868 17.3581L17.3581 8.51868Z\" fill=\"currentColor\"/>"
});
export default Icon;